import { render } from "./LeftSection.vue?vue&type=template&id=3c46db8a&scoped=true"
import script from "./LeftSection.vue?vue&type=script&lang=js"
export * from "./LeftSection.vue?vue&type=script&lang=js"

import "./LeftSection.vue?vue&type=style&index=0&id=3c46db8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c46db8a"]])

export default __exports__